/* ═══════════════════════════════════════════════════════════════
   GK Technova — UI flourishes (Dawn-compatible, dependency-free)
   Every hook is guarded by element existence so it never throws on
   pages that don't include a given piece of chrome. Reuses the class
   hooks already defined in gkt-custom.css.
═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ---- Announcement bar: rotate messages ---- */
  function initAnnounce() {
    var track = document.querySelector('.gkt-announce .announce-track');
    if (!track) return;
    var msgs = track.querySelectorAll('.announce-msg');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % msgs.length;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
    }, 4000);
  }

  /* ---- Reveal on scroll (uses .reveal / .visible from gkt-custom.css) ---- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal:not(.visible), .reveal-left:not(.visible), .reveal-right:not(.visible), .reveal-scale:not(.visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Scroll progress (#scroll-progress width%) + back to top (.back-top .show) ---- */
  function initScroll() {
    var bar = document.getElementById('scroll-progress');
    var top = document.querySelector('.back-top');
    function onScroll() {
      var h = document.documentElement;
      var max = (h.scrollHeight - h.clientHeight) || 1;
      var pct = Math.min(h.scrollTop / max, 1) * 100;
      if (bar) bar.style.width = pct + '%';
      if (top) top.classList.toggle('show', h.scrollTop > 600);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (top) top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---- App-nav (sidebar / bottom nav) ---- */
  window.gktOpenCart = function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) { bubble.click(); return; }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  };
  window.gktSetActive = function (el) {
    if (!el || !el.parentElement) return;
    var group = el.parentElement.children;
    for (var i = 0; i < group.length; i++) group[i].classList.remove('active');
    el.classList.add('active');
  };

  /* ---- Sync GKT nav cart badges with Dawn cart count ---- */
  function syncCartBadges() {
    var src = document.getElementById('cart-icon-bubble');
    var count = 0;
    if (src) {
      var b = src.querySelector('.cart-count-bubble span[aria-hidden="true"]') ||
              src.querySelector('.cart-count-bubble span');
      if (b) count = parseInt(b.textContent, 10) || 0;
    }
    document.querySelectorAll('.js-gkt-cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ---- Cookie banner (.cookie) ---- */
  function initCookie() {
    var el = document.querySelector('.gkt-cookie');
    if (!el) return;
    try {
      if (localStorage.getItem('gkt_cookie_choice')) { el.style.display = 'none'; return; }
    } catch (e) {}
    el.style.display = 'flex';
    function choose(v) {
      try { localStorage.setItem('gkt_cookie_choice', v); } catch (e) {}
      el.style.display = 'none';
    }
    var a = el.querySelector('[data-cookie-accept]');
    var d = el.querySelector('[data-cookie-decline]');
    if (a) a.addEventListener('click', function () { choose('all'); });
    if (d) d.addEventListener('click', function () { choose('essential'); });
  }

  /* ---- FAQ accordion (.faq-item / .faq-q / .faq-a) ---- */
  function initFaq() {
    document.querySelectorAll('.faq-q').forEach(function (q) {
      if (q.dataset.gktBound) return;
      q.dataset.gktBound = '1';
      q.addEventListener('click', function () {
        var item = q.closest('.faq-item');
        if (!item) return;
        var ans = item.querySelector('.faq-a');
        var isOpen = item.classList.toggle('open');
        if (ans) ans.style.maxHeight = isOpen ? ans.scrollHeight + 'px' : '';
      });
    });
  }

  function init() {
    initAnnounce();
    initReveal();
    initScroll();
    initFaq();
    initCookie();
    syncCartBadges();
    document.addEventListener('cart:refresh', syncCartBadges);
    document.addEventListener('cart:updated', syncCartBadges);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  document.addEventListener('shopify:section:load', function () { initReveal(); initAnnounce(); initFaq(); });
})();
